import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, ListItem } from "@material-ui/core";
import CustomCheckbox from "../../Common/CustomCheckbox";

const useStyles = makeStyles(theme => ({
    container: {
        position: "relative",
        display: "block",
        marginBottom: 1,
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
    },
    checkbox: {
        position: "absolute",
        right: theme.spacing(2),
        top: 0,
        bottom: 0,
        marginTop: "auto",
        marginBottom: "auto",
        padding: 0
    }
}));

function RouteItem(props) {
    const { selected = false, background, onCheckboxClick } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <ListItem className={classes.container} style={{background: background}}>
            {
                onCheckboxClick &&
                <CustomCheckbox
                className={classes.checkbox}
                color="primary"
                checked={selected}
                onClick={onCheckboxClick}
                />
            }
            {props.children}
        </ListItem>
    );

}

export default RouteItem;

RouteItem.propTypes = {
    selected: PropTypes.bool,
    background: PropTypes.string,
    onCheckboxClick: PropTypes.func,
    children: PropTypes.object
};